<template>
  <div class="xcxloginbox">
    <div class="xcxlogin" v-show="!getCodeFlag">
      <div class="xcxlogin_top">
        <div class="xcxlogin_top_logo"></div>
        <div class="xcxlogin_top_textbox">
          <div class="xcxlogin_top_text_title">社区登录码</div>
          <div>
            请打开游戏APP-社区-我的-设置-社区登录码 获取<span @click="goGetcode(true)">?</span>
          </div>
        </div>
        <div class="xcxlogin_top_inputbox">
          <!-- <input v-model="loginCode" id="output" /> -->
          <van-field v-model="loginCode" name="请输入社区登录码" placeholder="请输入社区登录码" />
          <!-- <div class="xcxlogin_top_inputbox_btn" @click="paste">粘贴</div> -->
        </div>
      </div>
      <div class="xcxlogin_bottom">
        <div class="xcxlogin_bottom_btn" @click="loginClick">登录</div>
        <span class="xcxlogin_bottom_text" @click="goGetcode(true)">仍然找不到登录码</span>
      </div>
    </div>
    <getCode v-show="getCodeFlag" @goGetcode="goGetcode"></getCode>
  </div>
</template>
<script>
import getCode from './getCode.vue';
import http from '../../../api/get';
import * as _code from '../../../utils/code';
import qs from 'qs';
import { Toast } from 'vant';
export default {
  name: 'xcxlogin',
  components: { getCode },
  data() {
    return {
      loginCode: '',
      getCodeFlag: false,
      userInfo: {}
    };
  },
  mounted() {
    // if (this.$store.state.token) {
    //   this.$router.push("/homePage");
    // }
  },
  methods: {
    loginClick() {
      if (this.loginCode == '') {
        Toast('请输入登录码');
      } else {
        let _this = this;
        let form = {
          openId: this.$store.state.openId,
          loginCode: this.loginCode,
          appKey: window.user.appkey
        };
        http.bindLogincode(qs.stringify(form)).then((res) => {
          if (res.data.code == 0) {
            if (res.data.code == 1013) {
              _this.$store.commit('changeBannedText', res.data.data);
              _this.$store.commit('changeStatus', 2);
            } else {
              let _data = res.data.data;
              _this.$store.commit('setUserInfo', _data);
              http.unReadMessageNum().then((res) => {
                let data = res.data;
                if (data.code == 0) {
                  _this.$store.commit('changeMessageNum', [data.data, true]);
                }
                window.user.topicIdWx
                  ? _this.$router.push({
                    path: '/topicPage',
                    query: {
                      topicId: window.user.topicIdWx,
                      isGame: true,
                      appletsFirst: true
                    }
                  })
                  : _this.$router.push('/homePage');
              });
            }
          } else {
            this.errorMessage(res.data);
          }
        });
      }
    },
    paste() {
      this.loginCode = this.getClipboard();
      // try {
      //   const text = await navigator.clipboard.readText();
      //   this.loginCode = text;
      //   alert("Pasted content: ", text);
      // } catch (err) {
      //   alert("Failed to read clipboard contents: ", err);
      // }
    },
    getClipboard() {
      var pasteTarget = document.createElement('div');
      pasteTarget.contentEditable = true;
      var actElem = document.activeElement.appendChild(pasteTarget).parentNode;
      pasteTarget.focus();
      document.execCommand('Paste', null, null);
      var paste = pasteTarget.innerText;
      actElem.removeChild(pasteTarget);
      return paste;
    },
    goGetcode(flag) {
      this.getCodeFlag = flag;
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>
<style scoped></style>